import { render } from "./MomentItem.vue?vue&type=template&id=a663c44a"
import script from "./MomentItem.vue?vue&type=script&lang=js"
export * from "./MomentItem.vue?vue&type=script&lang=js"

import "./MomentItem.vue?vue&type=style&index=0&id=a663c44a&lang=scss"
script.render = render

export default script